import HttpRequest from './http_request'

class RefProvider extends HttpRequest {
  constructor() {
    // api api
    super(process.env.VUE_APP_ENDPOINT + 'api/reference/')
  }

  async getRegistrarFaculty() {
    const { data } = await this.get('/', {
      function: 'get-registrar-faculty',
    })
    return data
  }
  async getRegistrarCurriculum(level_id) {
    const { data } = await this.get('/', {
      function: 'get-registrar-curriculum',
      level_id,
    })
    return data
  }


  async getLevel() {
    const { data } = await this.get('/', {
      function: 'get-reference',
      table: 'LEVEL',
      select: ["LEVEL_ID", "LEVEL_NAME_TH", "LEVEL_NAME_EN"],
      order: [{
        LEVEL_ID: 'ASC'
      }]
    })
    return data
  }
  async getPrefixName() {
    const { data } = await this.get('/', {
      function: 'get-reference',
      table: 'PREFIX_NAME',
      select: ["PREFIX_NAME_ID", "FULLNAME_TH", "INITIALS_TH", "FULLNAME_EN", "INITIALS_EN", "GENDER", "AGE"],
    })
    return data
  }
  async getBloodType() {
    const { data } = await this.get('/', {
      function: 'get-reference',
      table: 'BLOOD_TYPE',
      select: ["BLOOD_TYPE_ID", "BLOOD_TYPE_NAME_TH", "BLOOD_TYPE_NAME_EN"],
    })
    return data
  }
  async getDisability() {
    const { data } = await this.get('/', {
      function: 'get-reference',
      table: 'DISABILITY',
      select: ["DISABILITY_ID", "DISABILITY_NAME_TH", "DISABILITY_NAME_EN"],
    })
    return data
  }
  async getDistrict() {
    const { data } = await this.get('/', {
      function: 'get-reference',
      table: 'DISTRICT',
      select: ["DISTRICT_ID", "DISTRICT_NAME_TH", "DISTRICT_NAME_EN", "PROVINCE_ID"],
    })
    return data
  }
  async getEducationType() {
    const { data } = await this.get('/', {
      function: 'get-reference',
      table: 'EDUCATION_TYPE',
      select: ["EDUCATION_TYPE_ID", "EDUCATION_TYPE_NAME_TH", "EDUCATION_TYPE_NAME_EN"],
    })
    return data
  }
  async getEducationTypeById(id) {
    const { data } = await this.get('/', {
      function: 'get-reference',
      table: 'EDUCATION_TYPE',
      select: ["EDUCATION_TYPE_ID", "EDUCATION_TYPE_NAME_TH", "EDUCATION_TYPE_NAME_EN"],
      where: [{EDUCATION_TYPE_ID: id}]
    })
    return data
  }
  async getGender() {
    const { data } = await this.get('/', {
      function: 'get-reference',
      table: 'GENDER',
      select: ["GENDER_ID", "GENDER_NAME_TH", "GENDER_NAME_EN"],
    })
    return data
  }
  async getGeography() {
    const { data } = await this.get('/', {
      function: 'get-reference',
      table: 'GEOGRAPHY',
      select: ["GEOGRAPHY_ID", "GEOGRAPHY_NAME_TH", "GEOGRAPHY_NAME_EN"],
    })
    return data
  }
  async getLoginErrorCode() {
    const { data } = await this.get('/', {
      function: 'get-reference',
      table: 'LOGIN_ERROR_CODE',
      select: ["LOGIN_ERROR_CODE_ID", "LOGIN_ERROR_CODE_NAME_TH", "LOGIN_ERROR_CODE_NAME_EN"],
    })
    return data
  }
  async getLoginService() {
    const { data } = await this.get('/', {
      function: 'get-reference',
      table: 'LOGIN_SERVICE',
      select: ["LOGIN_SERVICE_ID", "LOGIN_SERVICE_NAME_TH", "LOGIN_SERVICE_NAME_EN"],
    })
    return data
  }
  async getMatriculationStatus() {
    const { data } = await this.get('/', {
      function: 'get-reference',
      table: 'MATRICULATION_STATUS',
      select: ["MATRICULATION_STATUS_ID", "MATRICULATION_STATUS_NAME_TH", "MATRICULATION_STATUS_NAME_EN"],
    })
    return data
  }
  async getNation() {
    const { data } = await this.get('/', {
      function: 'get-reference',
      table: 'NATION',
      select: ["NATION_ID", "NATION_NAME_TH", "NATION_NAME_EN"],
    })
    return data
  }
  async getNationById(id) {
    const { data } = await this.get('/', {
      function: 'get-reference',
      table: 'NATION',
      select: ["NATION_ID", "NATION_NAME_TH", "NATION_NAME_EN"],
      where: [{NATION_ID: id}]
    })
    return data
  }
  async getOccupation() {
    const { data } = await this.get('/', {
      function: 'get-reference',
      table: 'OCCUPATION',
      select: ["OCCUPATION_ID", "OCCUPATION_NAME_TH", "OCCUPATION_NAME_EN"],
    })
    return data
  }
  async getParRelative() {
    const { data } = await this.get('/', {
      function: 'get-reference',
      table: 'PAR_RELATIVE',
      select: ["PAR_RELATIVE_ID", "PAR_RELATIVE_NAME_TH", "PAR_RELATIVE_NAME_EN"],
    })
    return data
  }
  async getParStatus() {
    const { data } = await this.get('/', {
      function: 'get-reference',
      table: 'PAR_STATUS',
      select: ["PAR_STATUS_ID", "PAR_STATUS_NAME_TH", "PAR_STATUS_NAME_EN"],
    })
    return data
  }
  async getPrivilege() {
    const { data } = await this.get('/', {
      function: 'get-reference',
      table: 'PRIVILEGE',
      select: ["PRIVILEGE_ID", "PRIVILEGE_NAME"],
    })
    return data
  }
  async getProvince() {
    const { data } = await this.get('/', {
      function: 'get-reference',
      table: 'PROVINCE',
      select: ["PROVINCE_ID", "PROVINCE_NAME_TH", "PROVINCE_NAME_EN", "GEOGRAPHY_ID"],
    })
    return data
  }
  async getRace() {
    const { data } = await this.get('/', {
      function: 'get-reference',
      table: 'RACE',
      select: ["RACE_ID", "RACE_NAME_TH", "RACE_NAME_EN"],
    })
    return data
  }
  async getReligion() {
    const { data } = await this.get('/', {
      function: 'get-reference',
      table: 'RELIGION',
      select: ["RELIGION_ID", "RELIGION_NAME_TH", "RELIGION_NAME_EN"],
    })
    return data
  }
  async getRevenue() {
    const { data } = await this.get('/', {
      function: 'get-reference',
      table: 'REVENUE',
      select: ["REVENUE_ID", "REVENUE_NAME_TH", "REVENUE_NAME_EN"],
    })
    return data
  }
  async getSchool() {
    const { data } = await this.get('/', {
      function: 'get-reference',
      table: 'SCHOOL',
      select: ["SCHOOL_ID", "SCHOOL_NAME_TH", "SCHOOL_NAME_EN", "PROVINCE_ID"],
    })
    return data
  }
  async getRegistrarSchoolByProvince(province_id) {
    const { data } = await this.get('/', {
      function: 'get-registrar-reference',
      table: 'school',
      select: ["SCHOOL_CODE", "SCHOOL_NAME", "PROV_ID"],
      where: [{PROV_ID: province_id}]
    })
    return data
  }
  async getRegistrarSchoolById(id) {
    const { data } = await this.get('/', {
      function: 'get-registrar-reference',
      table: 'school',
      select: ["SCHOOL_CODE", "SCHOOL_NAME", "PROV_ID"],
      where: [{SCHOOL_CODE: id}]
    })
    return data
  }
  async getSchoolType() {
    const { data } = await this.get('/', {
      function: 'get-reference',
      table: 'SCHOOL_TYPE',
      select: ["SCHOOL_TYPE_ID", "SCHOOL_TYPE_NAME_TH", "SCHOOL_TYPE_NAME_EN"],
    })
    return data
  }
  async getStudentStatus() {
    const { data } = await this.get('/', {
      function: 'get-reference',
      table: 'STUDENT_STATUS',
      select: ["STUDENT_STATUS_ID", "STUDENT_STATUS_NAME_TH", "STUDENT_STATUS_NAME_EN"],
    })
    return data
  }
  async getStudentStatusSub() {
    const { data } = await this.get('/', {
      function: 'get-reference',
      table: 'STUDENT_STATUS_SUB',
      select: ["STUDENT_STATUS_ID", "STUDENT_STATUS_SUB_ID", "STUDENT_STATUS_SUB_NAME_TH", "STUDENT_STATUS_SUB_NAME_EN", "STUDENT_STATUS_MHESI_ID"],
    })
    return data
  }
  async getStudentType() {
    const { data } = await this.get('/', {
      function: 'get-reference',
      table: 'STUDENT_TYPE',
      select: ["STUDENT_TYPE_ID", "STUDENT_TYPE_NAME_TH", "STUDENT_TYPE_NAME_EN"],
    })
    return data
  }
  async getSubDistrict() {
    const { data } = await this.get('/', {
      function: 'get-reference',
      table: 'SUB_DISTRICT',
      select: ["SUB_DISTRICT_ID", "SUB_DISTRICT_NAME_TH", "SUB_DISTRICT_NAME_EN", "DISTRICT_ID", "PROVINCE_ID"],
    })
    return data
  }
  async getTalent() {
    const { data } = await this.get('/', {
      function: 'get-reference',
      table: 'TALENT',
      select: ["TALENT_ID", "TALENT_NAME_TH", "TALENT_NAME_EN"],
    })
    return data
  }
  async getUniversity() {
    const { data } = await this.get('/', {
      function: 'get-reference',
      table: 'UNIVERSITY',
      select: ["UNIVERSITY_ID", "UNIVERSITY_NAME_TH", "UNIVERSITY_NAME_EN", "UNIVERSITY_PROVINCE_CODE"],
    })
    return data
  }
  async getUniversityById(id) {
    const { data } = await this.get('/', {
      function: 'get-reference',
      table: 'UNIVERSITY',
      select: ["UNIVERSITY_ID", "UNIVERSITY_NAME_TH", "UNIVERSITY_NAME_EN", "UNIVERSITY_PROVINCE_CODE"],
      where: [{UNIVERSITY_ID: id}]
    })
    return data
  }
  async getUniversityStudyStatus() {
    const { data } = await this.get('/', {
      function: 'get-reference',
      table: 'UNIVERSITY_STUDY_STATUS',
      select: ["UNIVERSITY_STUDY_STATUS_ID", "UNIVERSITY_STUDY_STATUS_NAME_TH", "UNIVERSITY_STUDY_STATUS_NAME_EN"],
    })
    return data
  }
  async getUniversityStudyStatusById(id) {
    const { data } = await this.get('/', {
      function: 'get-reference',
      table: 'UNIVERSITY_STUDY_STATUS',
      select: ["UNIVERSITY_STUDY_STATUS_ID", "UNIVERSITY_STUDY_STATUS_NAME_TH", "UNIVERSITY_STUDY_STATUS_NAME_EN"],
      where: [{UNIVERSITY_STUDY_STATUS_ID: id}]
    })
    return data
  }
  async getVitalStatus() {
    const { data } = await this.get('/', {
      function: 'get-reference',
      table: 'VITAL_STATUS',
      select: ["VITAL_STATUS_ID", "UNIVERSITY_NAME_TH", "UNIVERSITY_NAME_EN", "UNIVERSITY_PROVINCE_CODE"],
    })
    return data
  }
  async getZipcode() {
    const { data } = await this.get('/', {
      function: 'get-reference',
      table: 'ZIPCODES',
      select: ["ZIPCODE_ID", "SUB_DISTRICT_CODE", "ZIPCODE"],
    })
    return data
  }
  async getSchoolStudyStatus() {
    const { data } = await this.get('/', {
      function: 'get-reference',
      table: 'SCHOOL_STUDY_STATUS',
      select: ["SCHOOL_STUDY_STATUS_ID", "SCHOOL_STUDY_STATUS_NAME_TH", "SCHOOL_STUDY_STATUS_NAME_EN"],
    })
    return data
  }
  async getSchoolStudyStatusById(id) {
    const { data } = await this.get('/', {
      function: 'get-reference',
      table: 'SCHOOL_STUDY_STATUS',
      select: ["SCHOOL_STUDY_STATUS_ID", "SCHOOL_STUDY_STATUS_NAME_TH", "SCHOOL_STUDY_STATUS_NAME_EN"],
      where: [{SCHOOL_STUDY_STATUS_ID: id}]
    })
    return data
  }
  async getSchoolStudyType() {
    const { data } = await this.get('/', {
      function: 'get-reference',
      table: 'SCHOOL_STUDY_TYPE',
      select: ["SCHOOL_STUDY_TYPE_ID", "SCHOOL_STUDY_TYPE_NAME_TH", "SCHOOL_STUDY_TYPE_NAME_EN"],
    })
    return data
  }
  async getSchoolStudyTypeById(id) {
    const { data } = await this.get('/', {
      function: 'get-reference',
      table: 'SCHOOL_STUDY_TYPE',
      select: ["SCHOOL_STUDY_TYPE_ID", "SCHOOL_STUDY_TYPE_NAME_TH", "SCHOOL_STUDY_TYPE_NAME_EN"],
      where: [{SCHOOL_STUDY_TYPE_ID: id}]
    })
    return data
  }
  async getBank() {
    const { data } = await this.get('/', {
      function: 'get-reference',
      table: 'BANK',
      select: ["BANK_ID", "BANK_CODE", "BANK_NAME_TH", "BANK_NAME_EN"],
    })
    return data
  }
  async getAdmissionRegisterStatus() {
    const { data } = await this.get('/', {
      function: 'get-reference',
      table: 'ADMISSION_REGISTER_STATUS',
      select: ["ADMISSION_REGISTER_STATUS_ID", "ADMISSION_REGISTER_STATUS_NAME_TH", "ADMISSION_REGISTER_STATUS_NAME_EN"],
    })
    return data
  }
  async getStudyAdmitTypes() {
    const { data } = await this.get('/', {
      function: 'get-reference',
      table: 'STUDY_ADMIT_TYPE',
      select: ["STUDY_ADMIT_TYPE_ID", "STUDY_ADMIT_TYPE_NAME_TH", "STUDY_ADMIT_TYPE_NAME_EN"],
    })
    return data
  }
  async getStudyPlans() {
    const { data } = await this.get('/', {
      function: 'get-reference',
      table: 'STUDY_PLAN',
      select: ["STUDY_PLAN_ID", "STUDY_PLAN_NAME_TH", "STUDY_PLAN_NAME_EN", "LEVEL_ID"],
    })
    return data
  }
  async getStudyClasses() {
    const { data } = await this.get('/', {
      function: 'get-reference',
      table: 'STUDY_CLASSES',
      select: ["STUDY_CLASSES_ID", "STUDY_CLASSES_NAME_TH", "STUDY_CLASSES_NAME_EN"],
    })
    return data
  }
  async getSpecificNations() {
    const { data } = await this.get('/', {
      function: 'get-reference',
      table: 'SPECIFIC_NATION',
      select: ["SPECIFIC_NATION_ID", "SPECIFIC_NATION_NAME_TH", "SPECIFIC_NATION_NAME_EN"],
    })
    return data
  }
  async getAdmissionStatusInfos() {
    const { data } = await this.get('/', {
      function: 'get-reference',
      table: 'ADMISSION_STATUS_INFO',
      select: ["STATUS", "REFUSE", "MEANING_TH", "MEANING_EN"],
    })
    return data
  }
}

export default RefProvider